
/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */

 import { Polymer, html } from '@polymer/polymer/polymer-legacy.js'; 

 const template= html`
       <div class="flex-horizontal medium" > 
       <style> 
           
        </style>
         Credit Card Authorization

        <p id="rcorners2" >
        <!--credit Card number  starts  -->
        <gold-cc-input
                id="CreditCardAuth_number_input" 
                label="l_CreditCardNumber"
                auto-validate
                value="{{wrapperValueInput.CreditCardAuth_number_input}}"
                error-message="Invalid Card Number"
                type="password"
                required>
        </gold-cc-input>
            
        <!--credit Card number  ends  -->
       <!--PIN number element starts --> 
            <oe-input 
                      id="CreditCardAuth_pin_input" 
                      auto-validate 
                      char-counter 
                      prevent-invalid-input 
                      error-message="Only four digit number is allowed" 
                      pattern="[0-9]{4}"
                      maxlength='4' 
                      value="{{wrapperValueInput.CreditCardAuth_pin_input}}"
                      label="l_PIN" 
                      type="password" >
            </oe-input>
           
         <!--PIN number element ends --> 
            
         <!--Expiration Date starts-->
		<gold-cc-expiration-input 
                id="CreditCardAuth_expDate_input"
                label="l_ExpirationMonthYear"
                value="{{wrapperValueInput.CreditCardAuth_expDate_input}}"
                error-message="Invalid Expiration details"
                auto-validate
                required>
        </gold-cc-expiration-input>
        <!--Expiration Date ends-->   
        </p>    
            
      </div>`;

    Polymer({
      is: 'fin-auth-credit-card',
      _template:template,
      properties: {
          
          wrapperValue:{
              type: Array,
              value:[
                     { CreditCardAuth_number_input: {type: Number, notify: true}},
                     { CreditCardAuth_pin_input: {type: Number, notify: true }},
                     { CreditCardAuth_expDate_input: {type: Number , notify: true}} 
                   ],
               notify: true
          },  
          wrapperInputValue:{
              type: Array,
              value:[
                     { CreditCardAuth_number_input: {type: Number, notify: true}},
                     { CreditCardAuth_pin_input: {type: Number, notify: true }},
                     { CreditCardAuth_expDate_input: {type: Number , notify: true}} 
                   ],
               notify: true
          }
      },  
      observers: ['onwrapperValueChanged(wrapperValue.*)'],
      onwrapperValueChanged:function(){
        this.fire('auth-pass-changed',this.wrapperValue);
      },
      attached :function(){
          var self = this;
          var inputFeild = document.getElementById("CreditCardAuth_number_input");
          inputFeild.addEventListener("input", function(){
            self.wrapperValue.CreditCardAuth_number_input = sbEncrypt.encrypt(self.wrapperValueInput.CreditCardAuth_number_input);
            //if(self.wrapperValue.CreditCardAuth_number_input == ''){}
      
          });

          var inputFeild1 = document.getElementById("CreditCardAuth_pin_input");
          inputFeild1.addEventListener("input", function(){
            self.wrapperValue.CreditCardAuth_pin_input = sbEncrypt.encrypt(self.wrapperValueInput.CreditCardAuth_pin_input);
            //if(self.wrapperValue.CreditCardAuth_pin_input == ''){}
          
          });

          var inputFeild2 = document.getElementById("CreditCardAuth_expDate_input");
          inputFeild2.addEventListener("input", function(){
            self.wrapperValue.CreditCardAuth_expDate_input = sbEncrypt.encrypt(self.wrapperValueInput.CreditCardAuth_expDate_input);
            //if(self.wrapperValue.CreditCardAuth_expDate_input == ''){}
          
          });
      }          
      });


